import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex, Text } from '@mantine/core';

import { UserAvatar } from 'components/shared';
import { EditIcon, TrashIcon } from 'icons';
import type { QueueGroupType, QueueGroupUserType } from 'types';

import { QueueGroupDeleteModal } from './QueueGroupDeleteModal';
import { QueueGroupEditModal } from './QueueGroupEditModal';

type Props = {
  group: QueueGroupType;
};

export const QueueGroupsRow = ({ group }: Props) => {
  const [editModalOpened, setEditModalOpened] = useState(false);
  const [deleteModalOpened, setDeleteModalOpened] = useState(false);

  const { t } = useTranslation('organisations');

  return (
    <tr key={group.id}>
      <td>
        <Text sx={{ marginBottom: 4 }}>{group.name}</Text>
        <Text fz={13} color="gray.5">
          {t('organisationView.boards.queueGroups.membersCount')}:{' '}
          {group.users.length}
        </Text>
      </td>
      <td>
        <Flex align="center">
          {group.users.map((user: QueueGroupUserType, i: number) => (
            <Box
              key={user.id}
              sx={{
                border: '1px solid white',
                borderRadius: '50%',
                position: 'relative',
                left: -10 * i,
              }}
            >
              <UserAvatar
                key={user.id}
                name={user.name}
                surname={user.surname}
                avatar={user.avatarUrl}
              />
            </Box>
          ))}
        </Flex>
      </td>
      <td>
        <Flex gap="md" justify="flex-end">
          <EditIcon onClick={() => setEditModalOpened(true)} />
          <TrashIcon color="red" onClick={() => setDeleteModalOpened(true)} />
        </Flex>
        <QueueGroupEditModal
          opened={editModalOpened}
          onClose={() => setEditModalOpened(false)}
          queueGroup={group}
        />
        <QueueGroupDeleteModal
          opened={deleteModalOpened}
          onClose={() => setDeleteModalOpened(false)}
          queueGroup={group}
        />
      </td>
    </tr>
  );
};
